var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighMeter96(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0003 25.0834C7.87917 25.0834 2.91699 20.1212 2.91699 14C2.91699 7.87886 7.87917 2.91669 14.0003 2.91669C20.1215 2.91669 25.0837 7.87886 25.0837 14C25.0837 16.9395 23.916 19.7586 21.8374 21.8371C19.7589 23.9156 16.9398 25.0834 14.0003 25.0834ZM14.0003 3.50002C8.20133 3.50002 3.50033 8.20103 3.50033 14C3.50033 19.799 8.20133 24.5 14.0003 24.5C19.7993 24.5 24.5003 19.799 24.5003 14C24.5003 8.20103 19.7993 3.50002 14.0003 3.50002ZM20.1749 8.23669L19.7637 7.82544L15.4295 12.1596C15.0219 11.8396 14.5185 11.666 14.0003 11.6667C12.7117 11.6667 11.667 12.7114 11.667 14C11.667 15.2887 12.7117 16.3334 14.0003 16.3334C15.289 16.3334 16.3337 15.2887 16.3337 14C16.3343 13.4818 16.1607 12.9785 15.8407 12.5709L20.1749 8.23669ZM14.0003 15.75C13.0338 15.75 12.2503 14.9665 12.2503 14C12.2503 13.0335 13.0338 12.25 14.0003 12.25C14.9668 12.25 15.7503 13.0335 15.7503 14C15.7503 14.9665 14.9668 15.75 14.0003 15.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41732 14H5.83398C5.83386 11.0496 7.42518 8.32845 9.99669 6.8819C12.5682 5.43535 15.72 5.48831 18.2415 7.02044L17.9498 7.51627C15.6075 6.08739 12.676 6.03524 10.2843 7.37989C7.89256 8.72454 6.41374 11.2562 6.41732 14ZM20.9773 9.75335L20.4786 10.045C21.2048 11.2362 21.5873 12.605 21.584 14H22.1673C22.1676 12.5021 21.7559 11.033 20.9773 9.75335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighMeter96);
export default __webpack_public_path__ + "static/media/high-meter_96.d0bd0fc383147ff36d31581dc63de820.svg";
export { ForwardRef as ReactComponent };